import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { TruckDriver } from '@paragon/contract-library';

interface TruckDriversState {
  [truckDriverGuid: string]: TruckDriver;
}

const initialState: TruckDriversState = {};

const truckDriversSlice = createSlice({
  name: 'truckDrivers',
  initialState,
  reducers: {
    truckDriversLoaded: (state, action: PayloadAction<readonly TruckDriver[]>) => {
      for (const truckDriver of action.payload) {
        state[truckDriver.guid] = castDraft(truckDriver);
      }
    },
  },
});

export const { truckDriversLoaded } = truckDriversSlice.actions;
export const truckDrivers = truckDriversSlice.reducer;
